export default __webpack_public_path__ + "static/media/vegan.da299e4d.png";